import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors'
import { typography } from '../../shared/theme/typography';
import { ticketSurfaces } from '../../shared/ticket/ticketSurfaces.styles';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: ticketColors.bg,
    padding: 0,
  },
  containerCompact: {
    padding: 0,
  },
  list: {
    flex: 1,
  },
  stack: {
    gap: 10,
  },
  listSheet: {
    overflow: 'hidden',
  },
  catalogGridWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
    padding: spacing.sm,
  },
  listContent: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
    paddingBottom: spacing.md,
    gap: 0,
  },
  listContentEmptyGrow: {
    flexGrow: 1,
  },
  catalogGridRow: {
    gap: spacing.sm,
  },
  catalogGridCell: {
    flexGrow: 1,
    flexBasis: '47%',
    minWidth: 0,
  },
  catalogGridCellFull: {
    width: '100%',
  },
  footerLoading: {
    paddingVertical: spacing.lg,
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
  },
  footerLoadingText: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  emptyLoading: {
    marginTop: spacing.xl,
    paddingVertical: spacing.xxl,
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.md,
  },
  emptyLoadingText: {
    ...typography.body,
    color: ticketColors.ink2,
  },
  emptyState: {
    ...ticketSurfaces.paperSheet,
    ...ticketSurfaces.paperSheetPadded,
    marginTop: spacing.sm,
    borderRadius: 14,
    alignItems: 'center',
    gap: spacing.sm,
  },
  emptyStateEmbedded: {
    marginTop: 0,
    borderRadius: 0,
    borderWidth: 0,
    borderTopWidth: StyleSheet.hairlineWidth,
  },
  emptyTitle: {
    ...typography.titleXL,
    color: ticketColors.ink,
  },
  emptySubtitle: {
    ...typography.body,
    color: ticketColors.ink2,
    textAlign: 'center',
  },
  /** Empty Square: título/meta afuera + nest CTA adentro (proto). */
  emptyProto: {
    paddingVertical: 16,
    paddingHorizontal: 14,
    gap: 4,
  },
  emptyProtoTitle: {
    fontSize: 18,
    fontWeight: '800',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  emptyProtoMeta: {
    fontSize: 13,
    color: ticketColors.ink2,
    lineHeight: 18,
    fontFamily: ticketFonts.sans,
    marginBottom: 8,
  },
  /** Margen sobre botones POS (posUi.primaryButton / secondaryButton) */
  emptyActionPrimary: {
    marginTop: spacing.sm,
    alignSelf: 'stretch',
  },
  emptyActionSecondary: {
    marginTop: spacing.sm,
    alignSelf: 'stretch',
  },
});
